<p-tree class="" [value]="tree" [emptyMessage]="'entities.history.noChange' | translate">
  <ng-template let-node pTemplate="default">
    @if (action !== 'read') {
      <div>
        <b>{{ node.label }}</b>
        @if (node.data || node.children.length) {
          <b class="mr-2">:</b>
        }
        @if (node.data && node.data.newValue !== undefined) {
          <span>
            <span
                    [ngClass]="{
                        'text-success': node.data.oldValue === undefined,
                        'text-primary': node.data.oldValue !== undefined && node.data.newValue !== node.data.oldValue,
                    }"
              >
              {{ node.data.newValue ?? '-' }}
            </span>
            @if (node.data.oldValue !== undefined && node.data.newValue !== node.data.oldValue) {
              <span>
                ({{ node.data.oldValue ?? '-' }})
              </span>
            }
          </span>
        }
        @if (node.data && node.data.newValue === undefined && node.data.oldValue !== undefined) {
          <span
            class="text-danger"
            >
            {{ node.data.oldValue ?? '-' }}
          </span>
        }
      </div>
    }
    @if (action === 'read') {
      <div>
        <b>{{ node.label }}</b>
        @if (node.data || node.data === 0 || node.data === false) {
          <b class="mr-2">:</b>
        }
        <span>{{ node.data }}</span>
      </div>
    }
  </ng-template>
</p-tree>
